import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { Notification } from 'checkout/components/Notification'

import * as S from './styled'

const ContentNotification = ({
  itemName,
  isQuantityNotEqual,
  errors
}) => {
  if (isQuantityNotEqual && !errors.service_unavailable_for_the_region) {
    return (
      <S.NotificationWrapper>
        <Notification type="warning">
          <Text size="kilo" noMargin >
            Atenção! Você está selecionando uma{' '}
            <Text as="strong" size="kilo" noMargin bold>
              quantidade menor de serviços em relação aos produtos
            </Text>.
            Caso você queira{' '}
            <Text as="strong" size="kilo" noMargin bold>
              instalar a quantidade total de itens{' '}
            </Text>
            em sua obra ou projeto,{' '}
            <Text as="strong" size="kilo" noMargin bold>
              a quantidade selecionada de itens e serviços deverá ser igual
            </Text>.
          </Text>
        </Notification>
      </S.NotificationWrapper>
    )
  }

  if (errors.service_unavailable_for_the_region) {
    return (
      <S.NotificationWrapper>
        <Notification type="danger">
          <Text size="kilo" noMargin >
            <Text as="strong" size="kilo" noMargin bold>
              Atenção!{' '}
            </Text>
            O{' '}
            <Text as="strong" size="kilo" noMargin bold>
              {itemName} não está disponível{' '}
            </Text>
            para a{' '}
            <Text as="strong" size="kilo" noMargin bold>
              nova região selecionada
            </Text>.
            Estamos trabalhando para ampliar nossa área de abrangência.{' '}
            <Text as="strong" size="kilo" noMargin bold>
              Exclua o serviço do seu carrinho ou altere a região{' '}
            </Text>
            para seguir com a compra.
          </Text>
        </Notification>
      </S.NotificationWrapper>
    )
  }

  return null
}

export default ContentNotification
